import { controls } from "../controls";


const ms234 = {
    label: "Loan Installment Query",
    pageLabel: "Loan Installment Query",
    starting: true,
    url: "ms234",
    pageType: "history",
    filter: [
        ...controls.magicDateLabel({ tab: "filter", star: true, label: "Account Opening Date", width: "col-sm-2" }),
        ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "account_opening_date", width: "col-sm-2", default: "sessiondate" }),
        ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
        ...controls.magicDateLabel({ tab: "filter", label: "Maturity Date", width: "col-sm-2" }),
        ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "maturity_date", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
        ...controls.displayText({ star:true,tab: "filter", width: "col-sm-2", label: "Installment Type" }),
        ...controls.select({
            tab: "filter", width: "col-sm-4",
            options: [
                {
                    label: "Single Installment",
                    value: "single_installment"
                },
                {
                    label: "Principle + Actual Installment",
                    value: "principle_actual_installment"
                },
                {
                    label: "Flat Interest",
                    value: "flat_interest"
                },
                {
                    label: "EMI",
                    value: "emi"
                },
            ], name: "installment_type",
            isRequired:true
        }),
        ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
        ...controls.displayText({ tab: "filter", label: "No Of Installment", width: "col-sm-2" }),

        // ...controls.numberofinstallment({ tab: "filter" }),
        ...controls.numberOnly({ tab: "filter", placeHolder: "No Of Installment", name: "no_of_installment_month", width: "col-sm-2" }),
        ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

        ...controls.displayText({ tab: "filter", label: "Moratorium Period", width: "col-sm-2" }),
        ...controls.numberOnly({ tab: "filter", placeHolder: "Moratorium Period", name: "moratorium_period", width: "col-sm-2" }),
        ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
        ...controls.displayText({tab: "filter", label: "Loan Amount", width: "col-sm-2" ,star:true}),
    ...controls.numberOnly({ tab: "filter",placeHolder: "Loan Amount",isRequired:true,name: "loan_amount", width: "col-sm-2" }), 
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }), 
    ...controls.magicDateLabel({ tab: "filter", label: "Installment Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "installment_date", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ label: "Interest Rate", width: "col-sm-2",star:true }),
    ...controls.numberOnly({width: "col-sm-2",name:"ints_rate",data: "ints_rate" ,isRequired:true}),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({tab: "filter", label: "Installment Amount", width: "col-sm-2" ,}),
    ...controls.numberOnly({ tab: "filter",placeHolder: "Installment Amount",name: "installment_amount", width: "col-sm-2" }), 


    ],
    form: [],
    history: {
        perPage: 10,
        reportHeader: "User Statement",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        displayColumns: [
            {
                Header: "Date",
                accessor: "asondate",
                width: 150
            },
            {
                Header: "Srno",
                accessor: "srno",
                width: 150
            },
            {
                Header: "Inst Amount",
                accessor: "inst_amt"
            },
            {
                Header: "Interest",
                accessor: "interest"
            },
            {
                Header: "Required Balance",
                accessor: "required_bal",
                type:"currency"
            },
           
        ]
    }
}
export default ms234